import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface CardProps {
    heading: string;
    para: string;
    link: string;
    url: string;
    className?: string;
}

const Cards: React.FC = () => {
    return (
        <main className='tw-max-w-lvw tw-space-y-12 tw-py-12'>
            <div data-aos="fade-up" className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 
                 tw-place-items-center tw-gap-8 tw-max-w-[90%] lg:tw-max-w-[60%] tw-mx-auto">

                <Card
                    heading="File a claim"
                    para="Need to file a Protega claim or check the status of an existing claim?"
                    link="File a claim"
                    url="/customer-login"
                />
                <Card
                    heading="Customer Care"
                    para="Need more information about your Protega Coverage?"
                    link="Contact Customer Care"
                    url="/contact-form"
                />

                <Card
                    heading="Talk to Sales"
                    para="Learn more about how to generate revenue and mitigate fraud through modern post-purchase solutions like product and shipping protection."
                    link="Contact Sales"
                    url="/schedule-demo"
                    className="sm:tw-col-span-2"
                />
            </div>

            <div className="tw-max-w-[90%] lg:tw-max-w-[60%] tw-mx-auto">
                <Link to="/contact-address" className="tw-block tw-bg-[#151515] tw-rounded-xl tw-transition hover:tw-bg-[#1f1f1f]">
                    <div className="tw-p-6 md:tw-p-8 tw-flex tw-items-center tw-justify-between">
                        <h3 className="tw-text-[#00c5fb] tw-text-2xl tw-font-bold">Contact Details</h3>
                        <div className="tw-flex tw-items-center tw-gap-2 tw-text-[#00c5fb]">
                            <span className="tw-text-lg">Contact us</span>
                            <ChevronRight size={20} />
                        </div>
                    </div>
                </Link>
            </div>
        </main>
    );
};

const Card: React.FC<CardProps> = ({ heading, para, link, url, className = "" }) => {
    return (
        <div
            data-aos="fade-up"
            className={`tw-w-full tw-h-64 tw-p-8 tw-rounded-xl hover:tw-scale-105 tw-shadow-slate-800 hover:tw-shadow-lg tw-transition-all tw-flex tw-flex-col tw-justify-between tw-bg-[#1515169e] ${className}`}>
            <div className="tw-space-y-4">
                <h2 className="tw-text-2xl tw-font-medium tw-text-[#00C5FB]">{heading}</h2>
                <p className="tw-text-white">{para}</p>
            </div>
            <Link to={url} target='_blank' className="tw-flex tw-items-center tw-text-[#00C5FB] tw-pt-2 hover:tw-underline">
                {link} <ChevronRight className="tw-ml-2" />
            </Link>
        </div>
    );
};

export default Cards;